import type { VoltalisEvent, VoltalisEventData } from "~domain/events/models/event-model.ts";
import type {
  BackofficeFindSiteEventTreeResponse,
  BackofficeFindSiteEventTreeResponseItem,
} from "~infrastructure/api/backoffice/contract/site/responses/backoffice-find-site-event-tree-response.ts";

export const SiteEventMapper = {
  fromBackofficeSiteEventsToDomain(backofficeSiteEvent: BackofficeFindSiteEventTreeResponse): Array<VoltalisEvent> {
    return backofficeSiteEvent.map(SiteEventMapper.fromBackofficeSiteEventToDomain);
  },
  fromBackofficeSiteEventToDomain(backofficeSiteEvent: BackofficeFindSiteEventTreeResponseItem): VoltalisEvent {
    return {
      data: SiteEventMapper.fromBackofficeSiteEventDataToDomain(backofficeSiteEvent.data),
      children: SiteEventMapper.fromBackofficeSiteEventsToDomain(backofficeSiteEvent.children),
      truncated: backofficeSiteEvent.truncated,
    };
  },
  fromBackofficeSiteEventDataToDomain(
    backofficeSiteEventData: BackofficeFindSiteEventTreeResponseItem["data"],
  ): VoltalisEventData {
    return {
      id: backofficeSiteEventData.id,
      siteId: backofficeSiteEventData.siteId,
      closureDatetime: backofficeSiteEventData.closureDate ?? undefined,
      creationDatetime: backofficeSiteEventData.createDateTime,
      description: backofficeSiteEventData.description ?? undefined,
      eventCategory: backofficeSiteEventData.eventCategory,
      forecastDatetime: backofficeSiteEventData.forecastDate ?? undefined,
      isOpen: backofficeSiteEventData.isOpen ?? false,
      modificationDatetime: backofficeSiteEventData.modificationDate ?? undefined,
      operator: !backofficeSiteEventData.operator
        ? undefined
        : {
            id: backofficeSiteEventData.operator.id,
            firstname: backofficeSiteEventData.operator.firstname ?? undefined,
            lastname: backofficeSiteEventData.operator.lastname ?? undefined,
          },
      operatorDescription: backofficeSiteEventData.operatorDescription ?? undefined,
      priority: backofficeSiteEventData.priority ?? undefined,
      status: backofficeSiteEventData.status ?? undefined,
    };
  },
};
